import { formatText, formatVal, valToPercent } from '../../../../helpers/value'

export const schema = {
  yearsOfOperation: {
    key: 'yearsOfOperation',
    title: 'industryOverview.businessYears.YEARS_OF_OPERATION',
    thStyle: {},
    format: (val) => formatText(val),
  },
  numberCompanies: {
    key: 'numberCompanies',
    title: 'industryOverview.businessYears.NUMBER_OF_COMPANIES',
    thStyle: {
      justifyContent: 'flex-end',
    },
    format: (val, locale) => formatVal(val, locale, false, 0),
  },
  totalPercentCompanies: {
    key: 'totalPercentCompanies',
    title: 'industryOverview.businessYears.TOTAL_COMPANIES_PERCENT',
    thStyle: {
      justifyContent: 'flex-end',
    },
    format: (val, locale) => valToPercent(val, locale),
  },
}
